import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=5da66180&scoped=true"
import script from "./deal.vue?vue&type=script&lang=js"
export * from "./deal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da66180",
  null
  
)

export default component.exports